import React from 'react'

export const testimonies = [
  {
    title: (
      <>
        Le bruit de fond n’est pas trop pénible mais les pics sont
        insupportables
      </>
    ),
    titleSup: <>Témoignage d’une famille lausannoise</>,
    infos: <>Joaquim Manzoni</>,
    location: <>Lausanne</>,
    sound: 'lausanne.mp3',
    soundCaption: (
      <>
        Le bruit de la circulation capté le soir, près du domicile de Laura et
        Joaquimm Manzoni.
      </>
    ),
    text: (
      <>
        <p>
          Quand ils ont emménagé au pied de la rue du Valentin, à Lausanne,
          Laura et Joaquim Manzoni savaient. Une telle montée, qui plus est
          précédée d’un rond-point, est propice aux coups d’accélérateur qui
          s’embarrassent peu du voisinage. «Mais l’appartement présente beaucoup
          d’avantages et nous nous y sommes installés en mai 2017.» Quatre ans
          et deux semi-confinements plus tard, comment le couple et ses deux
          enfants vivent-ils avec le bruit routier? «Le bruit de fond n’est pas
          trop pénible mais les pics sont insupportables. On sursaute à chaque
          fois», répond Joaquim Manzoni.
        </p>
        <figure>
          <img src={require('../../images/lausanne.jpg')} />
          <figcaption>
            Joaquim et Laura Manzoni habitent en bas de la très pentue rue du
            Valentin depuis 2017. Odile Meylan
          </figcaption>
        </figure>
        <p>
          La configuration des rues invite en effet les conducteurs à mettre les
          gaz sous le balcon familial. «Certains se réjouissent. Un habitant du
          quartier possède une Maserati, il pourrait partir directement vers le
          haut du Valentin, mais il préfère descendre et faire le rond-point
          pour ensuite accélérer dans la montée. C’est son petit plaisir tous
          les matins.» Il n’est pas seul, il y a tous les autres, ceux qui «ne
          font même pas exprès»: les deux-roues, les camions qui manœuvrent pour
          livrer les commerces du quartier et quelques vieux bus des Transports
          publics lausannois, de ceux «qui font vibrer l’immeuble quand ils
          démarrent».
        </p>
        <blockquote>
          <p>
            «Un voisin possède une Maserati. Il pourrait partir directement vers
            le haut du Valentin, mais il préfère descendre et faire le
            rond-point pour ensuite accélérer dans la montée. C’est son petit
            plaisir tous les matins.»
          </p>
          <hr />
          <footer>— Joaquim Manzoni</footer>
        </blockquote>
        <p>
          À l’emménagement, le couple a modifié l’agencement du logement. Alors
          que les chambres étaient placées côté route, elles donnent désormais
          sur le petit parc situé à l’arrière de l’immeuble. Toute la famille
          échappe ainsi aux nuisances nocturnes. «Nous avons aussi la chance
          d’avoir de bonnes fenêtres dans la pièce à vivre. Le problème, c’est
          qu’elles restent ouvertes tout l’été car l’immeuble est mal isolé»,
          explique Laura Manzoni. La voisine du dessous est restée à l’ancien
          modèle, paraît-il. «Je peux vous dire qu’elle en souffre beaucoup.» Si
          Madame Manzoni n’imagine pas déménager à cause du bruit, Monsieur
          semble plus contrarié: «À la longue, c’est vraiment pesant. Il y a le
          bruit, mais aussi les autres aspects liés à la circulation, comme
          l’encombrement de l’espace public et la pollution. Le revers de la
          médaille quand vous habitez au centre d’une ville.»
        </p>
        <figure className='map'>
          <img src={require('../../images/map-lausanne.png')} />
          <figcaption>
            La rue du Valentin permet de rejoindre l’autoroute. Nos mesures
            proviennent du balcon au troisième étage au-dessus du giratoire avec
            l’avenue Alexandre-Vinet. La chaussée est particulièrement pentue en
            aval et en amont du rond-point.
          </figcaption>
        </figure>
        <p>
          Tous deux membres du Parti ouvrier populaire lausannois, les Manzoni
          sont favorables à ce que le 30 km/h de nuit soit étendu à Lausanne. Il
          faut dire que, pour l’instant, la mesure prend fin au pied de leur
          immeuble. «Ça offre une autre bonne raison d’accélérer en sortant du
          rond-point. Les conducteurs se retiennent sur l’avenue Vinet puis se
          lâchent pour monter le Valentin, observe Joaquim Manzoni. Mais juste
          en face, dans la zone concernée, les gens sont ravis. En termes de
          décibels, c’est le jour et la nuit.»
        </p>
      </>
    )
  },
  {
    title: (
      <>
        Nous avons régulièrement un dépôt noirâtre sur nos meubles, certainement
        dû aux pots d’échappement des véhicules.
      </>
    ),
    titleSup: <>Une famille victime des incivilités routières</>,
    infos: <>Joaquim Manzoni</>,
    location: <>Lausanne</>,
    sound: 'geneve-1.mp3',
    soundCaption: (
      <>
        Le bruit de la circulation capté le soir, près du domicile de Laura et
        Joaquimm Manzoni.
      </>
    ),
    text: (
      <>
        <p>
          Imaginez un instant vivre en permanence en pleine conversation. Une
          conversation qui ne s’arrêterait jamais, mais qui s’atténuerait
          légèrement la nuit. C’est le quotidien de Félicien et sa famille.
          Installés dans un bel appartement sur la route de Florissant, ils
          n’ouvrent presque jamais les fenêtres, prenant bien malgré eux le
          contre-pied des recommandations fédérales en cette période de
          pandémie.
        </p>
        <p>
          L’endroit où vit Félicien n’est certes pas le plus bruyant de Genève
          (64 dB(A) en moyenne en journée, donc légèrement en dessous des normes
          recommandées dans l’Ordonnance de protection contre le bruit), mais
          lui et sa famille font quotidiennement les frais de nombre
          d’incivilités routières.
        </p>
        <blockquote>
          <p>
            «Par chance,les fenêtres des chambres ne donnent pas de ce côté de
            la rue, si bien que nous passons des nuits relativement
            tranquilles.»
          </p>
          <hr />
          <footer>— Félicien </footer>
        </blockquote>
        <p>
          Le pic de décibels le plus élevé parmi nos 15 millions de mesures a
          été enregistré ici. Un samedi matin à 11 heures, un véhicule s’est
          tranquillement autorisé une accélération à 108 dB(A). Un peu comme si
          une scie circulaire s’invitait soudain sous votre fenê­tre à l’heure
          du brunch. Plus largement, l’appartement de Félicien possède un triste
          record: celui des pics de bruit les plus élevés enregistrés par nos
          appareils de mesure. «Le brouhaha ambiant, franchement, on s’habitue.
          Ce sont les pics de bruit qui sont agaçants. Nous vivons sur une ligne
          droite, et relativement loin des feux rouges; pour le coup, certains
          prennent de l’élan sous nos fenêtres», explique ce père de famille.
          Autre motif de nuisance: les pots d’échappement modifiés de façon
          illégale. «Par chance,les fenêtres des chambres ne donnent pas de ce
          côté de la rue, si bien que nous passons des nuits relativement
          tranquilles.»
        </p>
        <figure className='map'>
          <img src={require('../../images/map-geneve-2.png')} />
          <figcaption>
            La route de Florissant est un passage quasi obligé pour les
            pendulaires et les frontaliers. La circulation y est constante. Le
            rebord de fenêtre d'où proviennent nos mesures se trouve au
            rez-de-chaussée, à environ 5 mètres du bord de la route.
          </figcaption>
        </figure>
        <p>
          La famille a même connu une embellie durant le semi-confinement. «Nous
          sommes sur une route très fréquentée par les pendulaires et les
          frontaliers. Avec le couvre-feu fixé à 18 heures en France, les gens
          rentraient plus tôt chez eux et ça s’est beaucoup ressenti sur le
          trafic en fin de journée.» Autre bénéfice surprise du
          semi-confinement: la pollution. «Habituellement, nous avons
          régulièrement un dépôt noirâtre sur nos meubles, certainement dû aux
          pots d’échappement des véhicules. Cette pellicule s’est
          considérablement atténuée ces dernières semaines! J’imagine qu’il en
          va de même pour nos poumons…»
        </p>
      </>
    )
  },
  {
    title: (
      <>
        Avant d’habiter ici, je n’aurais jamais pensé que le bruit pouvait avoir
        un tel impact sur une personne
      </>
    ),
    titleSup: <>Un appartement de rêve qui se transforme en cauchemar</>,
    infos: <>Joaquim Manzoni</>,
    location: <>Lausanne</>,
    sound: 'geneve-2.mp3',
    soundCaption: (
      <>
        Le bruit de la circulation capté le soir, près du domicile de Laura et
        Joaquimm Manzoni.
      </>
    ),
    text: (
      <>
        <p>
          Après des mois et des mois de recherches, May* pensait avoir trouvé
          l’appartement de ses rêves à Genève, le nid parfait pour accueillir sa
          famille. Sept pièces sur près de 150m2, des hauts plafonds, une grande
          terrasse, de belles chambres pour son fils aîné et pour son bébé à
          naître, le tout situé sur la rue de Lausanne, à quelques enjambées de
          la Perle du Lac et de Mon Repos… Mais son rêve s’est rapidement
          transformé en cauchemar.
        </p>
        <p>
          «Nous avons visité cet appartement en plein confinement, lorsque les
          rues étaient désertes, mais nous avons rapidement déchanté lorsque les
          voitures sont revenues…» Et pour cause: les décibels qui l’entourent
          au quotidien à cause de la route explosent littéralement toutes les
          normes tolérées par l’Ordonnance de protection contre le bruit (OPB),
          de jour comme de nuit. Notre capteur a même enregistré une pointe
          maximum de 103dB(A), soit l’équivalent d’un concert de rock, juste
          sous sa fenêtre, un samedi à 17h. Plus largement, la limite de
          70dB(A), la valeur d’alarme selon l’OPB, est dépassée devant chez May
          13’268 fois par jour en moyenne.
        </p>
        <blockquote>
          <p>
            «Même à l’intérieur, fenêtres fermées, on entend le tramway ou bien
            les accélérations des voitures ou des motos.»
          </p>
          <hr />
          <footer>— May*</footer>
        </blockquote>
        <p>
          «Avant d’habiter ici, je n’aurais jamais pensé que le bruit pouvait
          avoir un tel impact sur une personne, je n’imaginais pas que c’était
          si dur au quotidien.» Soumise à ce stress auditif permanent, May a
          passé ses deux derniers mois de grossesse alitée, à cause de
          contractions incessantes. Perfide, le bruit s’immisce dans son
          quotidien. En pleine pandémie, il lui est impossible d’aérer les
          pièces sans conséquences sonores. De même, impensable pour May et les
          siens d’avoir une conversation lorsque les fenêtres sont ouvertes.
          Sans aucun répit, puisque sur cet axe, la circulation est intense
          également le week-end. «Même à l’intérieur, fenêtres fermées, on
          entend le tramway ou bien les accélérations des voitures ou des motos.
          La nuit, c’est très bruyant également, et ce malgré les doubles
          vitrages. Je n’ai jamais rien connu de tel!» Effectivement, sur le
          cadastre genevois du bruit, l’endroit où se trouve l’appartement de
          May est indiqué comme étant l’un des plus bruyants de Genève.
        </p>
        <figure className='map'>
          <img src={require('../../images/map-geneve-1.png')} />
          <figcaption>
            La rue de Lausanne est connue pour être particulièrement bruyante.
            Le point d'enregistrement de nos mesures se trouve au bord du
            trottoir, à mi-chemin entre un arrêt TPG et un feu rouge. Selon le
            cadastre du bruit routier, il s'agit de l'une des pires portions de
            route de Genève.
          </figcaption>
        </figure>
        <p>
          Le semi-confinement ne leur a apporté aucun confort auditif: «Nous
          nous attendions à connaître une amélioration, mais malheureusement,
          les nuisances sont exactement les mêmes qu’en temps normal. Seul le
          confinement total a eu des conséquences.» Pour cette famille, pas de
          solution. La régie qui gère l’immeuble refuse d’entendre leur
          souffrance. Les résidents continuent à payer les frais d’entretien
          d’une terrasse dont ils ne profitent jamais. Leur immeuble étant
          classé, impossible d’installer un pare-bruit pour faire oublier la
          route. Mettre des plantes pour atténuer le son leur reviendrait trop
          cher. «L’autre jour, j’ai tenté de prendre le soleil sur la terrasse,
          mais mon téléphone a sonné. J’ai décroché et mon interlocuteur a cru
          qu’il y avait un aspirateur à côté de moi… Il ne m’entendait même
          pas!»
        </p>
        <p>
          May a désormais un nouveau rêve: déménager. «Je pensais qu’il
          s’agissait de l’appartement d’une vie mais à présent, je n’arrive plus
          à me projeter dans l’avenir ici; ce manque total de tranquillité ne me
          semble pas viable à long terme. Ce n’est absolument pas l’endroit dans
          lequel j’imagine voir mes enfants grandir.»
        </p>
        <p>
          <i>* Nom connu de la rédaction</i>
        </p>
      </>
    )
  }
]
